import { ConfirmDialog, Stack, styled, Typography } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { GetIOEntityName } from 'scenes/IO/helpers';
import { createIo } from 'scenes/IO/sources/io';

import { create } from '../queryKeyFactory';

const Bold = styled(Typography)`
  font-weight: 500;
  margin: 0 8px 0 0;
`;

export const useCreateIo = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const createMutation = useMutation(create(), createIo, {
    successMessage: (_, io) => {
      const entityName = GetIOEntityName(io);

      return io.sendForApproval
        ? `${entityName} created`
        : `${entityName} saved as draft`;
    },
  });
  const handleAction = async ({ bpEmail, ...data }) => {
    if (bpEmail !== data.legalContact.email) {
      await showModal({
        title: `Update Business Partner’s Email?`,
        children: (
          <Stack>
            <Typography variant={'subtitle1'} color={'textSecondary'}>
              The entered legal person’s email is different from the current
              Business Partner’s.
            </Typography>
            <Stack direction={'row'}>
              <Bold variant={'subtitle1'} color={'textSecondary'}>
                Current:
              </Bold>
              <Typography variant={'subtitle1'} color={'textSecondary'}>
                {bpEmail}
              </Typography>
            </Stack>
            <Stack direction={'row'}>
              <Bold variant={'subtitle1'} color={'textSecondary'}>
                Entered:
              </Bold>
              <Typography variant={'subtitle1'} color={'textSecondary'}>
                {data.legalContact.email}
              </Typography>
            </Stack>
          </Stack>
        ),
        confirmActionLabel: 'update email',
      });
    }
    await createMutation.mutateAsync(data);
  };

  return [handleAction, createMutation];
};
